import { useState, useEffect } from 'react';
import * as Cesium from "cesium";
import tileToLatLon from '../utils/TileToLatLong';

export default function TerrainButtons({ viewerRef }) {
  
  // const position = Cesium.Cartesian3.fromDegrees(-74.0707383, 40.7117244, 100);
  // const pointGraphics = { pixelSize: 10 };

  const rainParticleSize = 15.0;
  const rainRadius = 100000.0// 100000.0;
  const rainImageSize = new Cesium.Cartesian2(rainParticleSize, rainParticleSize * 2.0);
  // let rainGravityScratch = new Cesium.Cartesian3();
  
  const rainUpdate = function (particle, dt, scene) {
  
    // const viewer = viewerRef.current.cesiumElement;
    // console.log("I am alive")
    let rainGravityScratch = new Cesium.Cartesian3();
    rainGravityScratch = Cesium.Cartesian3.normalize(particle.position, rainGravityScratch);
    rainGravityScratch = Cesium.Cartesian3.multiplyByScalar(rainGravityScratch, -1050.0, rainGravityScratch);
    particle.position = Cesium.Cartesian3.add(particle.position, rainGravityScratch, particle.position);
  
    // const distance = Cesium.Cartesian3.distance(scene.camera.position, particle.position);
    // if (distance > rainRadius) {
    //   particle.endColor.alpha = 0.0;
    // } else {
    //   particle.endColor.alpha = Cesium.Color.BLUE.alpha / (distance / rainRadius + 0.1);
    // }
    particle.endColor.alpha = 0.98;
  };

  const goToKML = async () => {
    if (viewerRef.current && viewerRef.current.cesiumElement) {

      let files = []

      for (let i = 19292; i <= 19303; i++) {
        for (let j = 23789; j <= 23797; j++) {
          files.push(`${i}/${j}.kml`);
        }
      }

      for (const file of files) {
        console.log(file);
        const dataSource = await Cesium.KmlDataSource.load(`http://localhost:8000/15/${file}`, {
          camera: viewerRef.current.cesiumElement.scene.camera,
          canvas: viewerRef.current.cesiumElement.scene.canvas,
          clampToGround: true
        });
        await viewerRef.current.cesiumElement.dataSources.add(dataSource);
      }

      // const viewer = viewerRef.current.cesiumElement;
      // const dataSource = await Cesium.KmlDataSource.load('http://localhost:8000/15/19300/23793.kml', {
      //   camera: viewer.scene.camera,
      //   canvas: viewer.scene.canvas,
      //   clampToGround: true
      // });
      // await viewer.dataSources.add(dataSource);
      // viewer.flyTo(dataSource);
    }
  };

  const goToKML2 = async () => {
    if (viewerRef.current && viewerRef.current.cesiumElement) {

      const viewer = viewerRef.current.cesiumElement;
      viewer.camera.flyTo({
        destination: Cesium.Rectangle.fromDegrees(152.87738274405348, -27.67824234628433, 153.34037444148868, -27.22697287641346),
      });

      let files = []

      for (let i = 15149; i <= 15170; i++) {
        for (let j = 6880; j <= 6903; j++) {
          files.push(`${i}/${j}.kml`);
        }
      }

      for (const file of files) {
        console.log(file);
        // const dataSource = await Cesium.KmlDataSource.load(`http://echodemo.com/artefacts/t6/14/${file}`, {
          const dataSource = await Cesium.KmlDataSource.load(`http://localhost:3001/14/${file}`, {
          camera: viewerRef.current.cesiumElement.scene.camera,
          canvas: viewerRef.current.cesiumElement.scene.canvas,
          clampToGround: true
        });
        await viewerRef.current.cesiumElement.dataSources.add(dataSource);
      }



      // const viewer = viewerRef.current.cesiumElement;
      // const dataSource = await Cesium.KmlDataSource.load('http://localhost:8000/15/19300/23793.kml', {
      //   camera: viewer.scene.camera,
      //   canvas: viewer.scene.canvas,
      //   clampToGround: true
      // });
      // await viewer.dataSources.add(dataSource);
      // viewer.flyTo(dataSource);
    }
  };

  const addTMSLayer = async () => {
    if (viewerRef.current && viewerRef.current.cesiumElement) {
      const viewer = viewerRef.current.cesiumElement;
      const scene = viewer.scene;
      console.log("Adding TMS Layer");

      // First fetch the list of KML files from the directory
      // const base = 'http://echodemo.com/artefacts/t6/14/';
      // const response = await fetch(base);
      // const text = await response.text();

      // // Parse the HTML directory listing to get KML files
      // const parser = new DOMParser();
      // const doc = parser.parseFromString(text, 'text/html');
      // const links = Array.from(doc.links)
      //   .map(link => link.href)
      //   .filter(href => href.endsWith('.kml'))
      //   .map(href => href.split('/').pop()); // Get just filename

      // let dataSource = null;
      // // Load each KML file
      // for (const kmlFile of links) {
      //   const kmlUrl = `${base}${kmlFile}`;
      //   try {
      //     dataSource = await Cesium.KmlDataSource.load(kmlUrl, {
      //       camera: viewer.scene.camera,
      //       canvas: viewer.scene.canvas,
      //       clampToGround: true
      //     });
      //     await viewer.dataSources.add(dataSource);
      //   } catch (error) {
      //     console.error(`Error loading ${kmlUrl}:`, error);
      //   }
      // }
      // const dataSource = await Cesium.KmlDataSource.load(url, {
      //   camera: viewer.scene.camera,
      //   canvas: viewer.scene.canvas
      // });
      // viewer.dataSources.add(dataSource);
      // viewer.flyTo(dataSource);

      // const resolutions = [
      //   0.703125, 0.3515625, 0.17578125, 0.087890625, 0.0439453125,
      //   0.02197265625, 0.010986328125, 0.0054931640625, 0.00274658203125,
      //   0.001373291015625, 0.0006866455078125, 0.00034332275390625,
      //   0.000171661376953125, 8.58306884765625e-05, 4.291534423828125e-05,
      //   2.1457672119140625e-05, 1.07288360595703125e-05, 5.36441802978515625e-06,
      //   2.68220901489257812e-06, 1.34110450744628906e-06, 6.70552253723144531e-07,
      //   3.35276126861572266e-07
      // ];

      // const tmsProvider = new Cesium.UrlTemplateImageryProvider({
      //   // url: 'http://localhost:8001/{z}/{x}/{reverseY}.png',
      //   url: 'http://echodemo.com/artefacts/t6/{z}/{x}/{reverseY}.png',
      //   fileExtension: 'png',
      //   tilingScheme: new Cesium.GeographicTilingScheme({
      //     numberOfLevelZeroTilesY: 1, // Standard value for EPSG:4326
      //     rectangle: Cesium.Rectangle.fromDegrees(152.87738274405348, -27.67824234628433, 153.34037444148868, -27.22697287641346), //Cesium.Rectangle.fromDegrees(11.321351, 44.474710, 11.367202, 44.511072),//Cesium.Rectangle.fromDegrees(-180, -90, 180, 90),
      //     resolutions: resolutions,
      //     tileWidth: 256,
      //     tileHeight: 256,
      //     camera: scene.camera,
      //     canvas: scene.canvas,
      //     clampToGround: true,
      //     screenOverlays: false,
      //   }),
      //   tileHeight: 256,
      //   tileWidth: 256,
      //   rectangle: Cesium.Rectangle.fromDegrees(152.87738274405348, -27.67824234628433, 153.34037444148868, -27.22697287641346), //Cesium.Rectangle.fromDegrees(11.321351, 44.474710, 11.367202, 44.511072),
      //   proxy: new Cesium.DefaultProxy('/proxy/'),
      //   customTags: {
      //     reverseY: (imageryProvider, x, y, level) => {
      //       const flippedY = String((1 << level) - 1 - y); // Correct formula for flipping Y value
      //       console.log(`Requesting tile: level=${level}, x=${x}, y=${flippedY}`);
      //       return flippedY;
      //     }
      //   }
      // });

      // const dataSource = new Cesium.CustomDataSource(tmsProvider)

      // const imageryLayer = new Cesium.ImageryLayer(tmsProvider);
      // viewer.imageryLayers.add(imageryLayer);

      // const modifiedKml = new XMLSerializer().serializeToString(kmlDoc);
      // const dataSource = await Cesium.KmlDataSource.load(
      //   'http://localhost:8000/tilemapresource.xml',
      //   {
      //     camera: scene.camera,
      //     canvas: scene.canvas,
      //     clampToGround: true,
      //     screenOverlays: false
      //   }
      // );

      // await viewer.dataSources.add(dataSource);
      // // dataSources.push({ dataSource, urls: new Set() })

      let animated_water = false;
      if (animated_water) {
        // Apply custom material to a primitive
        const customMaterial = new Cesium.Material({
          fabric: {
            type: 'Water',
            uniforms: {
              specularMap: 'assets/bol.png',
              normalMap: 'assets/waterNormals.jpg',
              baseWaterColor: new Cesium.Color(0.0, 0.5, 0.7, 1.0),
              blendColor: new Cesium.Color(0.0, 1.0, 1.0, 1.0),
              frequency: 100000.0,
              animationSpeed: 1,//0.1,
              amplitude: 10.0,
              specularIntensity: 1.0,
              fadeFactor: 1.0
            },
            source: `
              uniform sampler2D specularMap;
              uniform sampler2D normalMap;
              uniform vec4 baseWaterColor;
              uniform vec4 blendColor;
              uniform float frequency;
              uniform float animationSpeed;
              uniform float amplitude;
              uniform float specularIntensity;
              uniform float fadeFactor;

              czm_material czm_getMaterial(czm_materialInput materialInput)
              {
                  czm_material material = czm_getDefaultMaterial(materialInput);

                  float time = czm_frameNumber * animationSpeed;

                  // fade is a function of the distance from the fragment and the frequency of the waves
                  float fade = max(1.0, (length(materialInput.positionToEyeEC) / 10000000000.0) * frequency * fadeFactor);

                  float specularMapValue = texture(specularMap, materialInput.st).r;

                  // note: not using directional motion at this time, just set the angle to 0.0;
                  vec4 noise = czm_getWaterNoise(normalMap, materialInput.st * frequency, time, 0.0);
                  vec3 normalTangentSpace = noise.xyz * vec3(1.0, 1.0, (1.0 / amplitude));

                  // fade out the normal perturbation as we move further from the water surface
                  normalTangentSpace.xy /= fade;

                  // attempt to fade out the normal perturbation as we approach non water areas (low specular map value)
                  normalTangentSpace = mix(vec3(0.0, 0.0, 50.0), normalTangentSpace, specularMapValue);

                  normalTangentSpace = normalize(normalTangentSpace);

                  // get ratios for alignment of the new normal vector with a vector perpendicular to the tangent plane
                  float tsPerturbationRatio = clamp(dot(normalTangentSpace, vec3(0.0, 0.0, 1.0)), 0.0, 1.0);

                  // fade out water effect as specular map value decreases
                  material.alpha = mix(blendColor.a, baseWaterColor.a, specularMapValue) * specularMapValue;

                  // base color is a blend of the water and non-water color based on the value from the specular map
                  // may need a uniform blend factor to better control this
                  material.diffuse = mix(blendColor.rgb, baseWaterColor.rgb, specularMapValue);

                  // diffuse highlights are based on how perturbed the normal is
                  material.diffuse += (0.1 * tsPerturbationRatio);

                  material.diffuse = material.diffuse;

                  material.normal = normalize(materialInput.tangentToEyeMatrix * normalTangentSpace);

                  material.specular = specularIntensity;
                  material.shininess = 10.0;

                  return material;
              }
            `
          }
        });

        const primitive = viewer.scene.primitives.add(new Cesium.Primitive({
          geometryInstances: new Cesium.GeometryInstance({
            geometry: new Cesium.RectangleGeometry({
              // rectangle: tmsProvider.rectangle, // TURN BACK ON FOR VIZ
              vertexFormat: Cesium.MaterialAppearance.VERTEX_FORMAT
            })
          }),
          appearance: new Cesium.MaterialAppearance({
            material: customMaterial
          })
        }));

        // Add rain effect
        const rainParticleSystem = new Cesium.ParticleSystem({
          modelMatrix: new Cesium.Matrix4.fromTranslation(viewer.scene.camera.position),
          speed: -1.0,
          lifetime: 150.0,
          emitter: new Cesium.SphereEmitter(rainRadius),
          startScale: 1.0,
          endScale: 1.0,
          image: "assets/circular_particle.png",
          emissionRate: 9000.0,
          startColor: new Cesium.Color(0.27, 0.5, 0.7, 1.0),
          endColor: new Cesium.Color(0.27, 0.5, 0.7, 0.98),
          imageSize: rainImageSize,
          updateCallback: (particle, dt) => rainUpdate(particle, dt, viewer.scene),
        });

        scene.primitives.add(rainParticleSystem);
        console.log("Rain particle system added:", rainParticleSystem);

        viewer.scene.skyAtmosphere.hueShift = -0.97;
        viewer.scene.skyAtmosphere.saturationShift = 0.25;
        viewer.scene.skyAtmosphere.brightnessShift = -0.4;
        viewer.scene.fog.density = 0.025;
        viewer.scene.fog.minimumBrightness = 0.01;
      }

      // Zoom to the bounding box of the TMS layer
      viewer.camera.flyTo({
        // destination: Cesium.Rectangle.fromDegrees(11.321351, 44.474710, 11.367202, 44.511072)// tmsProvider.rectangle
        // destination: Cesium.Cartesian3.fromDegrees(-74.006, 40.7128, 10),
        destination: Cesium.Rectangle.fromDegrees(152.87738274405348, -27.67824234628433, 153.34037444148868, -27.22697287641346),
      });
    } else {
      console.log("Viewer is not initialized");
    }
  };

  const flyToTile = (z, x, y) => {
    if (viewerRef.current && viewerRef.current.cesiumElement) {
      const viewer = viewerRef.current.cesiumElement;
      const { lat, lon } = tileToLatLon(z, x, y);
      viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(lon, lat, 1000) // Adjust height as needed
      });
    }
  };

  const addCustomTerrainLayer = async () => {
    if (viewerRef.current && viewerRef.current.cesiumElement) {
      const viewer = viewerRef.current.cesiumElement;
      // var globe = viewer.scene.globe;
      console.log("Adding Custom Terrain Layer");

      var customTerrainProvider = new Cesium.CesiumTerrainProvider({
        url: 'http://localhost:8080/tilesets/nyc_coastal_3d_zeroed/',
      });

      viewer.globe = true
      var globe = viewer.scene.globe;
      terrainProvider = customTerrainProvider;

      // var defaultTerrainProvider = await Cesium.CesiumTerrainProvider.fromIonAssetId(1);

      let defaultTerrainProvider_boundary = [-74.02116073255685, 40.67959031817639, -73.96163836240410, 40.72621288097336]

      const minLon = -74.02116073255685, minLat = 40.67959031817639;
      const maxLon = -73.96163836240410, maxLat = 40.72621288097336;

      const corner1 = Cesium.Cartesian3.fromDegrees(minLon, minLat, 0);
      const corner2 = Cesium.Cartesian3.fromDegrees(maxLon, maxLat, 0);
      const boundarySphere = Cesium.BoundingSphere.fromPoints([corner1, corner2]);

      // globe.clippingPlanes = new Cesium.ClippingPlaneCollection({
      //   modelMatrix: Cesium.Transforms.eastNorthUpToFixedFrame(boundarySphere.center),
      //   planes: [
      //     new Cesium.ClippingPlane(new Cesium.Cartesian3(1.0, 0.0, 0.0),  boundarySphere.radius),
      //     new Cesium.ClippingPlane(new Cesium.Cartesian3(-1.0, 0.0, 0.0), boundarySphere.radius),
      //     new Cesium.ClippingPlane(new Cesium.Cartesian3(0.0, 1.0, 0.0),  boundarySphere.radius),
      //     new Cesium.ClippingPlane(new Cesium.Cartesian3(0.0, -1.0, 0.0), boundarySphere.radius)
      //   ],
      //   unionClippingRegions: true,
      //   edgeWidth: 1.0,
      //   edgeColor: Cesium.Color.WHITE,
      //   enabled: true
      // });
      // globe.backFaceCulling = false;
      // globe.showSkirts = false;

      // const tintProvider = new Cesium.SingleTileImageryProvider({
      //   url: "https://impact.ese.ic.ac.uk/Source/Assets/Textures/waterNormals.jpg"
      // });
      // const tintLayer = viewer.imageryLayers.addImageryProvider(tintProvider);
      // tintLayer.alpha = 0.7;
      // viewer.imageryLayers.raiseToTop(tintLayer);

      // const terrainProvider = new Cesium.CesiumTerrainProvider({
      //   url: 'http://localhost:8080/tilesets/terrain2/layer.json',
      //   // requestVertexNormals: true,
      //   // requestWaterMask: true,
      // });

      // console.log(terrainProvider)

      // viewer.terrainProvider = terrainProvider;

      // const blueMaterial = new Cesium.Material({
      //   fabric: {
      //     type: 'Color',
      //     uniforms: {
      //       color: new Cesium.Color(0.0, 0.0, 1.0, 0.5) // Blue color with 50% opacity
      //     }
      //   }
      // });

      // const terrainPrimitive = new Cesium.Primitive({
      //   geometryInstances: new Cesium.GeometryInstance({
      //     geometry: new Cesium.RectangleGeometry({
      //       rectangle: Cesium.Rectangle.fromDegrees(-180, -90, 180, 90),
      //       vertexFormat: Cesium.MaterialAppearance.VERTEX_FORMAT
      //     })
      //   }),
      //   appearance: new Cesium.MaterialAppearance({
      //     material: blueMaterial
      //   })
      // });

      // viewer.scene.primitives.add(terrainPrimitive);

      // viewer.camera.flyTo({
      //   destination: Cesium.Cartesian3.fromDegrees(-0.483118, 39.435293, 250) // Adjust coordinates as needed
      // });
    } else {
      console.log("Viewer is not initialized");
    }
  };

  const toggleTerrainLayer = () => {
    setUseGoogleTileset(!useGoogleTileset);
  };
  
  let buildingsAdded = false;
  const add3DBuildings = async () => {
    if (viewerRef.current && viewerRef.current.cesiumElement && !buildingsAdded) {
      const viewer = viewerRef.current.cesiumElement;
      viewer.scene.globe.depthTestAgainstTerrain = true;
      viewer.scene.fog.enabled = true;
      viewer.scene.globe.enableLighting = true;
      viewer.shouldAnimate = true;
      // viewer.scene.fog.density = 0.0001;

      // viewer.extend(viewerDragDropMixin); // Add this line

      try {
        const terrainProvider = await Cesium.CesiumTerrainProvider.fromIonAssetId(1);
        // terrainProvider.requestWaterMask = true;
        terrainProvider.showWaterEffect = true;
        viewer.terrainProvider = terrainProvider;


        const tileset = await Cesium.Cesium3DTileset.fromIonAssetId(2275207); // google = 2275207, osm = 96188
        viewer.scene.primitives.add(tileset);

        const extras = tileset.asset.extras;
        if (
          extras &&
          extras.ion &&
          extras.ion.defaultStyle
        ) {
          tileset.style = new Cesium.Cesium3DTileStyle(extras.ion.defaultStyle);
        }

        buildingsAdded = true;
      } catch (error) {
        console.log(error);
      }
    } else {
      // console.log("you didn't wait")
    }
  };

  /**/

  const [useGoogleTileset, setUseGoogleTileset] = useState(true);
  const [googleTileset, setGoogleTileset] = useState(null);
  useEffect(() => {
    const loadGooglePhotorealisticTileset = async () => {
      try {
        const tileset = await Cesium.createGooglePhotorealistic3DTileset({
          onlyUsingWithGoogleGeocoder: true,
        });
        if (viewerRef.current && viewerRef.current.cesiumElement) {
          const viewer = viewerRef.current.cesiumElement;
          viewer.scene.primitives.add(tileset);
          setGoogleTileset(tileset);
        }
      } catch (error) {
        console.log(`Error loading Photorealistic 3D Tiles tileset. ${error}`);
      }
    };

    if (useGoogleTileset) {
      loadGooglePhotorealisticTileset();
    } else {
      if (googleTileset && viewerRef.current && viewerRef.current.cesiumElement) {
        const viewer = viewerRef.current.cesiumElement;
        viewer.scene.primitives.remove(googleTileset);
        setGoogleTileset(null);
      }
      addCustomTerrainLayer(viewerRef, terrainProvider); // Pass terrainProvider here
    }
  }, [useGoogleTileset]);


  let [terrainProvider, setTerrainProvider] = useState(null);
  useEffect(() => {
    if (viewerRef.current) {
      const viewer = new Cesium.Viewer(viewerRef.current, {
        terrainProvider: terrainProvider,
        globe: false,
        sceneModePicker: false,
        baseLayerPicker: false,
      });
      viewerRef.current.cesiumElement = viewer;
      viewer.scene.skyAtmosphere.show = true;

      // Overcast atmosphere settings - less blue, more grey
      viewer.scene.skyAtmosphere.hueShift = -0.8;
      viewer.scene.skyAtmosphere.saturationShift = -0.5;
      viewer.scene.skyAtmosphere.brightnessShift = -0.2;

      // Enable fog for ground-level grey atmosphere
      viewer.scene.fog.enabled = true;
      viewer.scene.fog.density = 0.0003;
      viewer.scene.fog.minimumBrightness = 0.2;

      return () => {
        if (viewer && !viewer.isDestroyed()) {
          viewer.destroy();
        }
      };
    }
  }, [terrainProvider]);

  return (        
    <>
      {/* <button onClick={goToKML2} style={{ position: 'absolute', left: '10px', bottom: '350px', zIndex: 1 }}>addTMSLayer</button>
      <button onClick={add3DBuildings} style={{ position: 'absolute', left: '10px', bottom: '110px', zIndex: 1 }}>Enable 3D</button>
      <button onClick={goToKML} style={{ position: 'absolute', left: '10px', bottom: '140px', zIndex: 1 }}>Go to KML</button>
      <button onClick={addTMSLayer} style={{ position: 'absolute', left: '10px', bottom: '170px', zIndex: 1 }}>Add TMS Layer</button>
      <button onClick={addCustomTerrainLayer} style={{ position: 'absolute', left: '10px', bottom: '200px', zIndex: 1 }}>Add Custom Terrain</button>
      <button onClick={() => flyToTile(16, 19300, 23789)} style={{ position: 'absolute', left: '10px', bottom: '230px', zIndex: 1 }}>Fly to Tile</button>
      <button onClick={() => setShowActionGraph(!showActionGraph)} style={{ position: 'absolute', left: '10px', bottom: '260px', zIndex: 1 }}>Toggle ActionGraph</button>
      <button onClick={toggleTerrainLayer} style={{ position: 'absolute', left: '10px', bottom: '290px', zIndex: 1 }}>
        {useGoogleTileset ? 'Use Custom Terrain' : 'Use Google Tileset'}
      </button> */}
    </>
  )
}
